exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-select .draft-badge{border:1px solid #807e7e;text-transform:uppercase;border-radius:3px;font-size:.65rem;color:#807e7e;padding:3px 7px;text-align:center}", ""]);

// exports
